import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { NEWS__API } from "@/_helpers/urls";
import { NEWS__MUTATIONS } from "../mutation-types";
import { NEWS__ACTIONS } from "../action-types";
import Cookies from "js-cookie";

// State
const state = {
  news: [],
  newsCategoriesdetails: [],
  isLoading: false,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [NEWS__MUTATIONS.GETNEWS](state, data) {
    state.news = data?.data;
  },
  [NEWS__MUTATIONS.VIEWNEWSDETAILS](state, data) {
    state.newsCategoriesdetails = data;
  },
  SET_LOADING(state, status) {
    state.isLoading = status;
  },
};

// Actions
const actions = {
  async [NEWS__ACTIONS.GETNEWS]({ commit, state }, parameter) {
    try {
      commit("SET_LOADING", true);

      const response = await HTTP().get(NEWS__API.GETNEWS);
     //console.log(response);return;
      commit(NEWS__MUTATIONS.GETNEWS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
  async [NEWS__ACTIONS.VIEWNEWSDETAILS]({ commit }, id) {
    try {
        const url = NEWS__API.VIEWNEWSDETAILS(id);
        const response = await HTTP().get(url);

        if (response.status === 200) {
        const contestData = response.data && response.data.data ? response.data.data : response.data;
        commit(NEWS__MUTATIONS.VIEWNEWSDETAILS, contestData);
        } else {
        commit(NEWS__MUTATIONS.VIEWNEWSDETAILS, null);
        }
    } catch (error) {
        console.log(error);
        commit(NEWS__MUTATIONS.VIEWNEWSDETAILS, null);
    }
    },
};
export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};